import { ValidationResultsState } from "@idw-types/state";
import { CaptureStepTypes } from "@enums/capture-step-types";
import { ValidationResult } from "@idw-types/common/validation-result";
import { ValidationResultsActionTypes, ValidationResultsActions } from "../actions/validation-results-actions";
import { ValidationTypes } from "@enums/validation-types";
import { CaptureStepValidationResults, ValidationResults } from "../../types/data/validation-results";

export const initialValidationResultsState: ValidationResultsState = {
	validationResults: {}
};

export const validationResultsReducer = (
	state: ValidationResultsState = initialValidationResultsState,
	action: ValidationResultsActions
) => {
	switch (action.type) {
		case ValidationResultsActionTypes.INITIALIZE_VALIDATION_RESULTS:
			return {
				validationResults: action.payload.validationResults
			};
		case ValidationResultsActionTypes.SET_CAPTURE_STEP_VALIDATION_RESULT:
			return {
				validationResults: setCaptureStepValidationResult(state.validationResults, action.payload.captureStepType, action.payload.validationType, action.payload.validationResult)
			};
		case ValidationResultsActionTypes.SET_CAPTURE_STEP_VALIDATION_RESULTS:
			return {
				validationResults: setCaptureStepValidationResults(state.validationResults, action.payload.captureStepType, action.payload.captureStepValidationResults)
			};
		default:
			return state;
	}
};

const setCaptureStepValidationResult = (
	validationResults: ValidationResults,
	captureStepType: CaptureStepTypes,
	validationType: ValidationTypes,
	validationResult: ValidationResult
) => {
	const newResults = {
		...validationResults,
		[captureStepType]: {
			...validationResults[captureStepType],
			[validationType]: validationResult
		}
	};
    return newResults;
};

const setCaptureStepValidationResults = (
	validationResults: ValidationResults,
	captureStepType: CaptureStepTypes,
	captureStepValidationResults: CaptureStepValidationResults
) => {
	const newResults = {
		...validationResults,
		[captureStepType]: captureStepValidationResults
	};
    return newResults;
};